module.exports = __webpack_public_path__ + "static/media/series-thumbnail.4c53a750.svg";